import { Component, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'ui-full-size-image',
  templateUrl: './ui-full-size-image.component.html',
  styleUrls: ['./ui-full-size-image.component.scss']
})
export class UiFullSizeImageComponent {
  @Input() imgUrl: string;

  constructor(public modal: NgbActiveModal) {
  }

  public close(): void {
    this.modal.dismiss();
  }
}
